import { UserCog } from "lucide-react";

// "Managed by Jane Doe" — the community manager(s) running a community, on every card/row.
export function ManagedBy({ tenant, testid, className = "" }) {
  const ms = tenant?.managers || [];
  const label = ms.length === 0 ? "No manager assigned" : ms.length === 1 ? ms[0].name : `${ms[0].name} +${ms.length - 1}`;
  const title = ms.length > 1 ? ms.map((m) => m.name).join(", ") : undefined;
  return (
    <span data-testid={testid} title={title} className={`inline-flex items-center gap-1 text-[11px] truncate ${ms.length ? "text-ink/45" : "text-amber-700 font-semibold"} ${className}`}>
      <UserCog className={`h-3 w-3 shrink-0 ${ms.length ? "text-ink/35" : ""}`} strokeWidth={2} />
      {ms.length ? <>Managed by <span className="font-semibold text-ink/70">{label}</span></> : label}
    </span>
  );
}

// Filter helpers shared by the Communities pages.
export const managerOptions = (tenants) => {
  const m = new Map();
  tenants.forEach((t) => (t.managers || []).forEach((x) => m.set(x.user_id, x.name)));
  return [...m.entries()].map(([id, name]) => ({ id, name })).sort((a, b) => a.name.localeCompare(b.name));
};
export const matchesManager = (t, sel) => {
  if (!sel || sel === "all") return true;
  const ms = t.managers || [];
  if (sel === "none") return ms.length === 0;
  return ms.some((m) => m.user_id === sel);
};
export const managerSortKey = (t) => ((t.managers || [])[0]?.name || "\uffff").toLowerCase();
